import { render } from "./index.vue?vue&type=template&id=629524ec&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=629524ec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629524ec"],['__file',"src/views/SignUp/OtpVerification/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "629524ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('629524ec', __exports__)) {
    console.log('reload')
    api.reload('629524ec', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=629524ec&scoped=true", () => {
    console.log('re-render')
    api.rerender('629524ec', render)
  })

}


export default __exports__